import { Empty, Table, Tag, Tooltip } from "antd";
import { observer } from "mobx-react";
import { __ } from "../../../../../utils";
import { AccountLicenseActivationActions } from ".";
const {
  Column
} = Table;
const AccountLicenseActivationsTable = observer(_ref => {
  let {
    records
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Table, {
    bordered: true,
    locale: {
      emptyText: /*#__PURE__*/React.createElement(Empty, {
        description: __("This license has not yet been activated or is not currently active on any installation.")
      })
    },
    pagination: false,
    dataSource: records,
    rowKey: row => row.data.id,
    size: "small",
    showHeader: records.length > 0
  }, /*#__PURE__*/React.createElement(Column, {
    title: __("Hostname / Domain"),
    dataIndex: "host",
    key: "host",
    render: (_, _ref2) => {
      let {
        host,
        lastSeen,
        isConnectionLost,
        data: {
          type
        }
      } = _ref2;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("code", null, host), /*#__PURE__*/React.createElement(Tag, {
        style: {
          marginLeft: 10
        },
        color: type === "production" ? "green" : "warning"
      }, type === "production" ? __("Production") : __("Development")), isConnectionLost && /*#__PURE__*/React.createElement(Tooltip, {
        title: __("The license server last had contact with this installation on %s. Maybe you deleted it in the meantime? If so, you can revoke the activation and use the license on another website.", lastSeen.toLocaleString())
      }, /*#__PURE__*/React.createElement(Tag, {
        style: {
          marginLeft: 10
        },
        color: "error"
      }, __("Connection lost"))));
    }
  }), /*#__PURE__*/React.createElement(Column, {
    title: __("Product version"),
    dataIndex: "pluginVersion",
    key: "pluginVersion",
    render: (_, _ref3) => {
      let {
        pluginVersion
      } = _ref3;
      return pluginVersion;
    }
  }), /*#__PURE__*/React.createElement(Column, {
    title: __("Actions"),
    dataIndex: "actions",
    key: "actions",
    align: "right",
    render: (_, record) => /*#__PURE__*/React.createElement(AccountLicenseActivationActions, {
      record: record
    })
  })));
});
export { AccountLicenseActivationsTable };